import React from "react";
import "./styles.css";

const TermsAndCondition = () => {
  return (
    <React.Fragment>
      <span className="root">
        <span className="header">
          ENDBENUTZER-LIZENZVERTRAG FÜR DIE SOFTWARE TREND AnyWARE®
        </span>

        <span className="lineBreak">
          WENN SIE AUF DIE UNTENSTEHENDE SCHALTFLÄCHE „EINVERSTANDEN“ KLICKEN,
          ERKLÄREN SIE SICH MIT DEN BEDINGUNGEN DIESES
          ENDBENUTZER-LIZENZVERTRAGES EINVERSTANDEN UND AN DIESE GEBUNDEN
        </span>

        <span>
          Dieser Endbenutzer-Lizenzvertrag (<b>EULA</b>), der gemäß Artikel 12
          von Zeit zu Zeit von uns geändert werden kann, ist ein
          rechtsverbindlicher Vertrag, der zwischen Ihnen als Einzelperson oder
          Einrichtung und TREND Networks Limited (<b>TREND</b>) geschlossen
          wird, damit Sie die Software TREND AnyWARE®, die zu diesem EULA gehört
          und damit in Zusammenhang stehende Medien, Druckschriften, Online-
          oder elektronische Dokumentationen und internetbasierte Dienste (
          <b>Software</b>) umfassen kann, benutzen und darauf zugreifen können.
          Die Software versetzt Sie in die Lage, eine Verbindung zu kompatiblen
          Testern, Geräten und Tools von TREND (<b>Tools</b>) aufzubauen und auf
          Daten von diesen zuzugreifen. Der Zugriff auf die Software kann über
          einen Web-Browser auf einem beliebigen Gerät erfolgen. Es ist
          ebenfalls möglich, die Software herunterzuladen und auf einem Computer
          zu installieren.
        </span>

        <span className="lineBreak">
          <b>
            WICHTIG: BITTE LESEN SIE SICH DIE BESTIMMUNGEN DIESES EULA
            AUFMERKSAM DURCH.
          </b>
          DER EULA ENTHÄLT WICHTIGE BESTIMMUNGEN, DIE SIE UND DIE BENUTZUNG DER
          SOFTWARE DURCH SIE BETREFFEN. BITTE VERGLEICHEN SIE DIESEN EULA IMMER
          MIT AKTUALISIERTEN FASSUNGEN, SOBALD DIESE VERÖFFENTLICHT WERDEN. MIT
          DER ERSTELLUNG EINES KONTOS, DER INSTALLATION ODER DEM SONSTIGEN
          ZUGRIFF ODER DER BENUTZUNG DER SOFTWARE ODER VON TEILEN DAVON
          BESTÄTIGEN SIE, DASS SIE DIE BESTIMMUNGEN DIESES EULA GELESEN UND
          VERSTANDEN HABEN SOWIE DASS SIE SICH IN IHREM EIGENEN NAMEN UND
          GEGEBENENFALLS IM NAMEN DES UNTERNEHMENS ODER DER EINRICHTUNG, BEI
          DEM/DER SIE ANGESTELLT SIND ODER DAS/DIE SIE VERTRETEN, DAMIT
          EINVERSTANDEN ERKLÄREN, AN DIE BESTIMMUNGEN DIESES EULA GEBUNDEN ZU
          SEIN. WENN SIE MIT DEM EULA NICHT EINVERSTANDEN SIND, DÜRFEN SIE AUF
          DIE SOFTWARE NICHT ZUGREIFEN, SIE NICHT INSTALLIEREN, KOPIEREN ODER
          BENUTZEN. WENN SIE MIT DEN AKTUALISIERTEN FASSUNGEN DIESES EULA NICHT
          EINVERSTANDEN SEIN SOLLTEN, HABEN SIE NICHT LÄNGER DAS RECHT ODER DIE
          BERECHTIGUNG, AUF DIE SOFTWARE ZUZUGREIFEN ODER DIESE ZU BENUTZEN. IN
          DIESEM FALL HABEN SIE DIE SOFTWARE UNVERZÜGLICH ZU DEINSTALLIEREN
          UND/ODER DEN ZUGRIFF AUF DIE SOFTWARE SOWIE DEREN BENUTZUNG ZU
          BEENDEN.
        </span>

        <span className="lineBreak">
          SIE VERSICHERN UND BEKRÄFTIGEN HIERMIT, DASS SIE DIESEN EULA IM RAHMEN
          IHRER GESCHÄFTSTÄTIGKEIT ODER FÜR GESCHÄFTLICHE ZWECKE UND NICHT ALS
          VERBRAUCHER ABSCHLIESSEN. FALLS JEDOCH GEMÄSS DEN ANWENDBAREN GESETZEN
          VERBRAUCHERSCHUTZGESETZE GELTEN, BEEINTRÄCHTIGT UND BESCHRÄNKT DIESER
          EULA KEINE GESETZLICHEN VERBRAUCHERRECHTE, DIE IHNEN GEMÄSS DEN
          ANWENDBAREN GESETZEN ZUSTEHEN. WENN SIE DIESEN EULA IM NAMEN EINES
          UNTERNEHMENS ODER EINES ANDEREN RECHTSSUBJEKTES ABSCHLIESSEN,
          VERSICHERN UND BEKRÄFTIGEN SIE, DASS SIE BERECHTIGT SIND, EIN SOLCHES
          UNTERNEHMEN ODER EIN SOLCHES RECHTSSUBJEKT AN DIE BESTIMMUNGEN DES
          EULA ZU BINDEN. IN DIESEM FALL BEZIEHEN SICH DIE WÖRTER „SIE“" UND
          „IHR“ EBENFALLS AUF DAS UNTERNEHMEN ODER RECHTSSUBJEKT, DAS SIE
          VERTRETEN ODER BEI DEM SIE ANGESTELLT SIND, SOWIE AUF DEREN
          TOCHTERGESELLSCHAFTEN, ALLE DIREKTOREN, LEITENDE ANGESTELLTE,
          ANGESTELLTE, HANDLUNGSBEAUFTRAGTE UND VERTRETER.
        </span>

        <ol>
          <li>
            <b> BENUTZUNG DER SOFTWARE</b>
            <ol>
              <li>
                Vorbehaltlich Ihrer Einhaltung der Bestimmungen dieses EULA
                gewährt TREND Ihnen ein nicht ausschließliches, nicht
                übertragbares, nicht unterlizenzierbares, widerrufliches Recht,
                Objektcode-Versionen der Software herunterzuladen, zu
                installieren, zu aktivieren, darauf zuzugreifen oder auf
                sonstige Weise auf einem Gerät, das sich in Ihrem Besitz oder
                unter Ihrer Kontrolle befindet, ausschließlich und einzig für
                Ihre internen Geschäftsabläufe, wie von diesem EULA erlaubt, zu
                benutzen.
              </li>
              <li>
                Sie dürfen einem Dritten und/oder Benutzern in Ihrem Unternehmen
                oder Ihrer Einrichtung (<b>zugelassene Benutzer</b>) das Recht
                gewähren, die Software im normalen Arbeitsablauf zu benutzen und
                darauf zuzugreifen, wenn eine solche Nutzung ausschließlich
                erfolgt: (i) in Ihrem Namen, (ii) für Ihre internen
                Geschäftsabläufe und (iii) in Übereinstimmung mit diesem EULA.
                Sie gewährleisten, dass alle Ihre zugelassenen Benutzer den
                Bestimmungen dieses EULA zustimmen und davon in Kenntnis gesetzt
                wurden und zugestimmt haben, dass TREND ihre personenbezogenen
                Daten gemäß der Datenschutzerklärung von TREND erfasst, nutzt
                und weitergibt, bevor Sie Ihren zugelassenen Benutzern den
                Zugriff auf die Software ermöglichen. Jeder Verweis auf „Sie“
                und „Ihr“ in diesem EULA ist auch als Verweis auf Ihre
                zugelassenen Benutzer auszulegen. Sie sind dafür verantwortlich,
                dass: (a) alle zugelassenen Benutzer identifiziert und
                authentifiziert sind, (b) der Zugriff dieser zugelassenen
                Benutzer auf die Software durch Sie genehmigt ist, (c) die
                zugelassenen Benutzer diesen EULA einhalten, (d) der unbefugte
                Zugriff oder die unbefugte Nutzung durch zugelassene Benutzer
                verhindert wird, (e) die Vertraulichkeit von Benutzernamen,
                Passwörtern und Kontodaten gesichert ist und dass (f) Sie
                insbesondere vor der Aktivierung der Standortbestimmungsfunktion
                an den Tools von den zugelassenen Benutzern alle erforderlichen
                Mitteilungen oder Zustimmungen, die von den geltenden Gesetzen
                gefordert werden, erhalten oder diesen geben. TREND ist nicht
                haftbar für Schäden, die von Ihren zugelassenen Benutzern
                verursacht werden. Darin eingeschlossen sind Schäden, die durch
                Einzelpersonen verursacht wurden, die nicht zum Zugriff auf die
                Software befugt aber dazu in der Lage waren, weil Benutzernamen,
                Passwörter oder Konten nicht rechtzeitig in Ihrer lokalen
                Identitätsmanagement-Infrastruktur, auf Ihren lokalen Geräten
                oder auf sonstige Weise durch Sie oder in Ihrem Namen gesperrt
                wurden. Sie sind für alle Aktivitäten haftbar, die unter oder in
                Verbindung mit Ihren Benutzernamen, Passwörtern und Konten oder
                den Benutzernamen, Passwörtern und Konten Ihrer zugelassenen
                Benutzer oder als Folge davon durchgeführt werden, dass Sie oder
                Ihre zugelassenen Benutzer auf die Software zugreifen und Sie
                erklären sich einverstanden, TREND unverzüglich in Schriftform
                über jede unbefugte Benutzung zu informieren. Sie erklären sich
                einverstanden, alle angemessenen Anstrengungen zu unternehmen,
                um zu verhindern, dass unbefugte Dritte auf die Software
                zugreifen. Sie sind für alle Handlungen und Unterlassungen aller
                zugelassenen Benutzer haftbar und haben TREND gegen alle Kosten,
                Auslagen, Forderungen Verluste und Schäden, die TREND entstehen
                oder für die TREND möglicherweise direkt, indirekt oder
                beiläufig haftbar gemacht wird, einschließlich gegen
                wirtschaftlichen Verlust oder Gewinnausfall, den Verlust von
                Aufträgen oder den Verlust an Goodwill, die sich aus einer
                Handlung oder einer Unterlassung von zugelassenen Benutzern
                ergeben, schadlos zu halten.
              </li>
              <li>
                Sie haben mindestens einen zugelassenen Benutzer als
                Administrator (<b>Administrator</b>) Ihres Kontos festzulegen.
                Sie erklären sich einverstanden, dass der Administrator in Ihrem
                Namen jederzeit und aus gleich welchem Grund die Zugriffs- und
                Benutzungsrechte anderer zugelassenen Benutzer für die Software
                gewähren und widerrufen darf. Sie können Ihre(n)
                Administrator(en) jederzeit und aus gleich welchem Grund
                wechseln, indem Sie einen oder mehrere neue Administratoren
                festlegen.
              </li>
              <li>
                Sie erklären sich einverstanden, dass Sie allein für Ihre
                Benutzung der Software, für jede Verletzung Ihrer Pflichten
                gemäß diesem EULA sowie für die Folgen einer solchen Verletzung,
                einschließlich für Verluste oder Schäden, die TREND unter
                Umständen als Folge einer solchen Verletzung erleidet, haften
                und dass TREND Ihnen oder Dritten gegenüber von jeder Haftung in
                dieser Hinsicht freigestellt ist.
              </li>
              <li>
                Sie können auf Ihren Geräten mit einem Web-Browser auf die
                Software zugreifen. Eine eigenständige Version kann
                heruntergeladen und auf einem PC mit Microsoft Windows als
                Betriebssystem installiert werden. Diese eigenständige Version
                erlaubt über eine Direktverbindung ohne das Internet die
                Kommunikation mit den Tools.
              </li>
              <li>
                Um die Software herunterzuladen, zu installieren, darauf
                zuzugreifen oder sonst wie zu benutzen, müssen Sie sich für ein
                Konto anmelden. TREND behält sich das Recht vor, diese Anmeldung
                nach alleinigem Ermessen zu verweigern. Für die Benutzung der
                Software durch Sie erklären Sie sich einverstanden: (i)
                richtige, aktuelle und vollständige Kontodaten anzugeben, (ii)
                Ihre Kontodaten zu pflegen und unverzüglich zu aktualisieren,
                (iii) die Sicherheit Ihrer Passwörter zu gewährleisten und alle
                Risiken eines unbefugten Zugriffs auf Ihr Konto und auf die von
                Ihnen an TREND übermittelten Daten zu tragen und (iv) TREND
                unverzüglich zu informieren, wenn Sie feststellen oder sonst wie
                den Verdacht haben, dass es in Bezug auf die Software oder Ihre
                Benutzung derselben zu einer Sicherheitsverletzung gekommen ist.
              </li>
              <li>
                Um TREND in die Lage zu versetzen, den Service, die Wartung und
                den Support der Software zu gewährleisten, gewähren Sie TREND
                den Zugriff, den TREND benötigt, um TREND zu ermöglichen, sich
                in Ihrem Konto anzumelden und Ihr Konto so zu führen, als ob Sie
                es selbst führen würden. Dieser autorisierte Zugriff umfasst
                auch das Recht von TREND, Ihre Daten anzuzeigen, zu ändern und
                zu löschen.
              </li>
              <li>
                In dem laut Gesetz zulässigen Umfang darf TREND Ihre Daten in
                dem Maße löschen, in dem eine Handlung oder Unterlassung
                Ihrerseits diesen EULA verletzt. TREND ist bemüht, Sie vor dem
                Löschen Ihrer Daten zu benachrichtigen, wobei dieser EULA nicht
                verletzt wird, sollte eine solche vorherige Benachrichtigung
                nicht erfolgen. Wenn Sie Ihre Daten herunterladen und von
                unseren Servern oder unseren Dritt-Servern löschen, ist es nicht
                mehr möglich, über die Software oder über unsere Server oder
                unsere Dritt-Server auf diese heruntergeladenen oder gelöschten
                Daten zuzugreifen.
              </li>
              <li>
                Sie allein sind dafür verantwortlich, auf eigene Kosten alle
                Hilfsmittel, Geräte, Software, Dienstleistungen und sonstige
                Ressourcen, insbesondere Computer- und Geräte-Hardware und
                -Software, Modems, Telefondienste und Internetzugänge,
                bereitzustellen und zu warten, die benötigt werden, um die
                Software und die Tools zu benutzen.
              </li>
              <li>
                Sie sind sich bewusst, dass für Ihre Benutzung der Software
                möglicherweise eine Internetverbindung erforderlich ist, und
                dass Ihnen während der Benutzung der Software in Verbindung mit
                den von Ihrem Gerät übertragenen (gesendeten oder empfangenen)
                Daten möglicherweise Datengebühren entstehen. Sie allein sind
                für diese Datengebühren haftbar.
              </li>
            </ol>
          </li>

          <li>
            <b> RECHTS- UND EIGENTUMSVORBEHALT</b>
            <ol>
              <li>
                Die Software wird an Sie ausschließlich zur Benutzung gemäß den
                Bestimmungen dieses EULA in Lizenz vergeben und nicht verkauft.
                Das Eigentumsrecht und alle anderen Rechte an: (i) der Software,
                insbesondere an allen geistigen Eigentumsrechten und an (ii)
                allen Inhalten und anderen darin enthaltenen Materialien, die
                TREND oder unsere Dritt-Lizenzgeber bereitgestellt haben,
                insbesondere die Logos von TREND und TREND AnyWARE® sowie alle
                Designs, Texte, Grafiken, Bilder, Informationen, Daten,
                Software, Audio- oder andere Dateien sowie die Auswahl und die
                Anordnung derselben (gemeinsam als Inhalte bezeichnet) sind das
                gesetzlich geschützte Eigentum von TREND oder gegebenenfalls
                unserer Lizenzgeber und sind nach dem Urheberrecht und anderen
                geistigen Eigentumsrechten und anwendbaren Gesetzen geschützt
                und verbleiben bei TREND. TREND behält sich alle Rechte, die
                Ihnen nicht ausdrücklich gemäß diesem EULA gewährt werden, vor.
                Es werden, weder ausdrücklich noch stillschweigend, keine
                weiteren Rechte gewährt.
              </li>
              <li>
                „TREND“, „TREND Networks“, „TREND AnyWARE“, „LanTEK“, „TREND
                Networks“, „FiberTEK“, „SignalTEK“, „NaviTEK“, „SecuriTEST“,
                „LanXPLORER“, „UniPRO MGig1“ und die Logos von TREND Networks
                und TREND AnyWARE® sowie alle anderen Namen von Produkten oder
                Dienstleistungen, Logos oder Slogans von TREND, die
                möglicherweise in oder auf der Software oder den Inhalten
                erscheinen, sind Markenbezeichnungen von TREND. Ohne die
                vorherige schriftliche Genehmigung von TREND dürfen weder diese
                noch andere zum Verwechseln ähnliche Namen, Logos oder Slogans
                im Ganzen oder zum Teil kopiert, imitiert oder benutzt werden.
                Fremdmarken, die in oder auf der Software oder den Inhalten
                erscheinen, befinden sich im Eigentum von Dritten und dürfen
                ohne die Genehmigung des jeweiligen Markeninhabers nicht benutzt
                werden. Ohne die vorherige schriftliche Genehmigung dürfen Sie
                keine Metatags oder „verborgene Texte“ verwenden, die „TREND“
                oder einen anderen Namen, eine andere Marke oder einen anderen
                Produkt- oder Dienstleistungsnamen von TREND enthalten. Das
                Aussehen und der Eindruck der Software, einschließlich
                sämtlicher Seitenköpfe, spezifisch angepasster Grafiken,
                Button-Icons und Skripte, sind Dienstleistungsmarken, Marken
                und/oder Handelsaufmachungen von TREND und dürfen ohne unsere
                vorherige schriftliche Genehmigung weder im Ganzen noch zum Teil
                kopiert, imitiert oder benutzt werden. Der Verweis auf Produkte,
                Dienstleistungen, Prozesse oder sonstige Informationen in Form
                von Namen, Marken, Herstellern, Zulieferern oder sonstiger Art
                bedeutet oder impliziert keine Unterstützung, Förderung oder
                Empfehlung derselben durch TREND.
              </li>
            </ol>
          </li>

          <li>
            <b> EINSCHRÄNKUNGEN UND BEGRENZUNGEN </b>
            <ol>
              <li>
                Sie verstehen und sind einverstanden, dass Sie diese Software
                ausschließlich in einer Art und Weise benutzen dürfen, die alle
                geltenden Gesetze in dem Land einhalten, in dem Sie diese
                Software benutzen. Wenn Sie diesen EULA verletzen, können
                Anklagen und Schadensersatzforderungen gegen Sie erhoben werden.
              </li>
              <li>
                Sie selbst werden nicht und auch nicht erlauben, dass Dritte:
                <ol>
                  <li>
                    die Software oder die Inhalte herunterladen, installieren,
                    aktivieren, darauf zugreifen oder sonst wie auf einem Gerät
                    benutzen, das sich nicht in Ihrem Eigentum oder unter Ihrer
                    rechtmäßigen Kontrolle befindet.
                  </li>
                  <li>
                    die Ergebnisse von Testergebnissen, die durch die Benutzung
                    der Tools erlangt wurden, veröffentlichen, diskutieren,
                    übertragen oder auf sonstige Weise an Dritte verbreiten.
                  </li>
                  <li>
                    die Software im Ganzen oder teilweise übersetzen,
                    zusammenfassen, anpassen, verändern oder modifizieren und
                    auch nicht erlauben, dass ein Teil davon mit anderen
                    Programmen kombiniert oder in diese einbezogen wird.
                  </li>
                  <li>
                    den Quellcode der Software im Ganzen oder in Teilen durch
                    Reverse Engineering zurückentwickeln oder ihn dekompilieren
                    oder versuchen, ihn abzuleiten sowie die Software im Ganzen
                    oder in Teilen verändern oder disassemblieren, es sei denn,
                    eine solche Handlung ist nach den geltenden Gesetzen
                    ausdrücklich erlaubt und dann auch nur in dem jeweils
                    erlaubten Umfang.
                  </li>
                  <li>
                    gesetzlich geschützte Hinweise oder Marken auf der Software
                    entfernen oder verändern.
                  </li>
                  <li>
                    abgeleitete Werke auf Grundlage der Software insgesamt oder
                    von Teilen davon erstellen.
                  </li>
                  <li>
                    die Software außerhalb Ihres Unternehmens kopieren oder
                    reproduzieren.
                  </li>
                  <li>
                    die Software ohne die vorherige schriftliche Genehmigung von
                    TREND verkaufen, abtreten, lizenzieren, vertreiben,
                    vermieten, verleasen, in Unterlizenz vergeben, verleihen
                    oder bereitstellen oder auf sonstige Weise in gleich welcher
                    Form im Ganzen oder in Teilen einer Person zur Verfügung
                    stellen.
                  </li>
                  <li>
                    die Software auf unrechtmäßige Weise, für unrechtmäßige
                    Zwecke oder auf eine Weise benutzen, die diesen Bestimmungen
                    widerspricht, oder betrügerisch oder arglistig handeln, in
                    dem Sie beispielsweise unbefugt in die Software oder ein
                    Betriebssystem eindringen (Hacking) oder einen schädlichen
                    Code, wie Viren oder schädliche Daten, darin einfügen.
                  </li>
                  <li>
                    die geistigen Eigentumsrechte von TREND oder von Dritten in
                    Bezug auf die Benutzung der Software, einschließlich durch
                    das Übertragen von Material, verletzen, es sei denn eine
                    solche Benutzung ist in dem betreffenden Umfang durch diese
                    Bestimmungen erlaubt.;
                  </li>
                  <li>
                    verleumderisches, beleidigendes oder anderes Material
                    übertragen, das in Bezug auf Ihre Benutzung der Software zu
                    beanstanden ist.
                  </li>
                  <li>
                    die Software auf eine Weise benutzen, die die Software oder
                    die mit der Software verbundenen Server oder Netzwerke
                    beschädigen, deaktivieren, überlasten oder beeinträchtigen
                    könnte.
                  </li>
                  <li>
                    die Software auf eine Weise benutzen, die die Benutzung und
                    das positive Erlebnis der Software oder der mit der Software
                    verbundenen Server oder Netzwerke durch eine andere Person
                    stören könnte.
                  </li>
                  <li>
                    ohne die vorherige schriftliche Genehmigung von TREND
                    Drittanwendungen entwickeln, die mit der Software
                    zusammenwirken.{" "}
                  </li>
                  <li>
                    durch Ihre Benutzung der Software oder der Systeme von TREND
                    Informationen oder Daten erheben oder erfassen oder
                    versuchen, Übertragungen auf die Server oder von den
                    Servern, auf denen die Software läuft, zu entschlüsseln.
                  </li>
                  <li>
                    die Software für Zwecke, für die sie nicht entwickelt wurde
                    oder bestimmt ist oder für andere als hierin beschriebene
                    Zwecke benutzen.
                  </li>
                </ol>
              </li>
            </ol>
          </li>

          <li>
            <b> ERFASSUNG UND NUTZUNG VON DATEN</b>
            <ol>
              <li>
                Sie erklären sich einverstanden, dass TREND und seine
                Tochtergesellschaften im Rahmen der Ihnen gegebenenfalls
                bereitgestellten Produkt-Supportleistungen in Zusammenhang mit
                der Software technische Daten erfassen und nutzen dürfen. TREND
                darf diese Daten ausschließlich nutzen, um seine Produkte zu
                verbessern oder um Ihnen spezifisch angepasste Dienstleistungen
                oder Technologien zur Verfügung zu stellen, und wird diese Daten
                nicht in einer Form weitergeben, die Sie persönlich
                identifiziert.
              </li>
              <b className="subHeading">PERSONENBEZOGENE DATEN</b>
              <li>
                Sie erklären sich einverstanden, dass TREND, wenn Sie die
                Software herunterladen, installieren, aktivieren, darauf
                zugreifen oder auf sonstige Weise benutzen, mit Hilfe
                automatischer Mittel, einschließlich beispielsweise mit Cookies
                und Web-Beacons, Informationen zu Ihrem Gerät und zu Ihrer
                Benutzung der Software erfasst. Möglicherweise werden Sie und
                Ihre zugelassenen Benutzer auch aufgefordert, als Voraussetzung
                für das Herunterladen, Installieren, Aktivieren, den Zugriff auf
                oder die Benutzung der Software oder bestimmter
                Leistungsmerkmale oder Funktionen bestimmte persönliche Daten
                anzugeben. Gemäß der Datenschutzgesetzgebung sind wir
                verpflichtet, Ihnen bestimmte Informationen zu unserer
                Identität, zur Verarbeitung und zum Zweck der Verarbeitung Ihrer
                personenbezogenen Daten durch uns sowie zu Ihren Rechten in
                Bezug auf Ihre personenbezogenen Daten und wie Sie diese ausüben
                können, mitzuteilen. Diese Informationen sind in der
                Datenschutzerklärung (<b>Datenschutzerklärung</b>) von TREND
                enthalten, die Sie auf
                <a
                  href="https://www.trend-networks.com/de/privacy-policy/"
                  target="_blank"
                >
                  <b>
                    https://www.trend-networks.com/de/privacy-policy/
                  </b>
                </a>
                ,einsehen können und die von Zeit zu Zeit ohne vorherige
                Ankündigung aktualisiert werden kann. Es ist wichtig, dass Sie
                sich diese Datenschutzerklärung durchlesen. Mit dem
                Herunterladen, Installieren, Aktiveren , dem Zugriff auf oder
                dem Benutzen der Software und der Eingabe von Daten in oder über
                die Software erklären Sie sich mit allen Nutzungen und
                Handlungen von TREND in Bezug auf Ihre Daten gemäß der
                Datenschutzerklärung einverstanden.
              </li>
              <li>
                Bitte beachten Sie, dass Internet-Übertragungen niemals
                vollständig vertraulich oder sicher sind und dass Mitteilungen
                oder Daten, die Sie mit Hilfe der Software übermitteln,
                möglicherweise von anderen gelesen oder abgefangen werden, auch
                wenn eine besondere Meldung angezeigt wird, dass die betreffende
                Übertragung verschlüsselt erfolgt.
              </li>
              <b className="subHeading">ENDBENUTZER-DATEN </b>
              <li>
                In Verbindung mit der Software kann TREND von Ihnen oder in
                Ihrem Namen über die Software eingegebene oder hochgeladene
                Daten erfassen und pflegen. Darin eingeschlossen sind unter
                anderem Daten zu Ihrer Benutzung der Tools und zu deren
                zugelassenen Benutzern (<b>Endbenutzer-Daten</b>). Sie erklären,
                dass sich alle Endbenutzer-Daten in Ihrem Eigentum befinden und
                dass Sie allein für die Endbenutzer-Daten haften. TREND
                behandelt alle persönlich identifizierbaren Aspekte aller
                Endbenutzer-Daten gemäß der Datenschutzerklärung als
                vertraulich. Alle von TREND autorisierten Dritten, die
                möglicherweise auf die Endbenutzer-Daten Zugriff haben, sind zur
                Vertraulichkeit verpflichtet und haben alle relevanten
                Bestimmungen der Datenschutzgesetzgebung einzuhalten. Sie
                erklären sich einverstanden und gewähren TREND hiermit das
                unwiderrufliche, unbefristete, gebührenfreie, übertragbare und
                unterlizenzierbare Recht, die Endbenutzer-Daten im Ganzen oder
                teilweise und in dem Umfang zu nutzen, zu reproduzieren, zu
                verändern, anzupassen, zu übersetzen, weiterzugeben, zu
                vermarkten, abzutreten, zu übermitteln, zu verkaufen, zu
                vermieten, zu lizenzieren oder zu übertragen, der keine
                personenbezogenen Daten enthält. Mit dem Hochladen oder
                Übermitteln von Endbenutzer-Daten mit Hilfe der Software
                erklären und versichern Sie, dass: (i) solche Endbenutzer-Daten
                nicht durch eine Geheimhaltungsverpflichtung von Dritten, die
                durch die Nutzung dieser Endbenutzer-Daten gemäß den
                Bestimmungen dieses EULA verletzt werden würde, geschützt sind,
                (ii) sich alle Rechte an den Endbenutzer-Daten, die Sie
                erstellen, hochladen oder übertragen, in Ihrem Eigentum und
                unter Ihrer Kontrolle befinden oder dass Sie auf sonstige Weise
                alle erforderlichen Rechte besitzen, um solche Endbenutzer-Daten
                mit Hilfe der Software zu erstellen, hochzuladen oder zu
                übertragen, (iii) die Endbenutzer-Daten richtig und in keinster
                Weise irreführend oder schädigend sind und dass (iv) die
                Endbenutzer-Daten sowie die Benutzung, das Hochladen und das
                Übertragen derselben durch Sie die Bestimmungen dieses EULA oder
                anwendbarer Gesetze, Regeln oder Vorschriften nicht verletzt und
                nicht verletzen wird. Unbeschadet anderer Bestimmungen dieses
                EULA darf TREND jederzeit: (a) Endbenutzer-Daten löschen
                und/oder (b) Ihr Konto und Ihren Zugriff auf die Software
                sperren. Sie haben sicherzustellen, dass Sie von allen
                Endbenutzer-Daten, die Sie über die Software an TREND
                hochgeladen, übertragen oder eingereicht haben, Kopien behalten.
                TREND übernimmt Ihnen gegenüber keine Haftung gleich welcher Art
                für den Verlust von Endbenutzer-Daten und auch nicht für den
                Nutzungsausfall an der Software.
              </li>
              <b className="subHeading">DATEN VON TREND</b>
              <li>
                Sämtliche Informationen, insbesondere Daten, Analysen,
                Messungen, Berichte, Trends und Metriken, die aus den
                Endbenutzer-Daten generiert oder abgeleitet wurden oder auf
                diesen basieren oder sich auf diese beziehen (<b>TREND-Daten</b>
                ) sind das alleinige Eigentum von TREND. TREND hat das Recht,
                TREND-Daten in gleich welcher Form und für gleich welchen Zweck
                und auf gleich welche Weise zu nutzen, zu erfassen, zu
                speichern, zu erstellen, zusammenzufassen, zu untersuchen, zu
                analysieren, zu verändern, zu vermarkten, abzutreten, zu
                übertragen, zu verkaufen, zu vermieten, zu lizenzieren oder zu
                übermitteln..
              </li>
            </ol>
          </li>

          <li>
            <b> UPDATES</b>
            <ol>
              <li>
                TREND darf die Software, insbesondere den Funktionsumfang und
                das Erscheinungsbild der Software, ohne vorherige Ankündigung
                ändern.
              </li>
              <li>
                TREND kann von Zeit zu Zeit nach alleinigem Ermessen
                Aktualisierungen der Software entwickeln und bereitstellen, die
                Upgrades, Bug-Fixes, Patches und andere Fehlerbehebungen
                und/oder neue Leistungsmerkmale umfassen und die gemeinsam,
                einschließlich der betreffenden Dokumentation, als{" "}
                <b>Updates</b> bezeichnet werden. Updates können auch bestimmte
                Leistungsmerkmale und Funktionen vollständig ändern oder
                löschen. Sie erklären sich einverstanden, dass TREND nicht
                verpflichtet ist, Updates zur Verfügung zu stellen oder weiter
                zur Verfügung zu stellen oder bestimmte Leistungsmerkmale oder
                Funktionen zu ermöglichen. In Abhängigkeit von den Einstellungen
                auf Ihrem Gerät wird einer der beiden folgenden Prozesse
                ausgeführt, wenn Ihr Gerät mit dem Internet verbunden ist: (i)
                Die Software lädt automatisch alle verfügbaren Updates herunter
                und installiert diese oder (ii) Sie erhalten eine entsprechende
                Mitteilung oder werden aufgefordert, die verfügbaren Updates
                herunterzuladen und zu installieren. Um die Software in vollem
                Umfang nutzen zu können, müssen Sie alle Updates unverzüglich
                herunterladen und installieren. Sie erkennen an, dass die
                Software oder Teile davon möglicherweise nicht ordnungsgemäß
                funktionieren, falls Sie dies nicht tun. Weiterhin erklären Sie
                sich einverstanden, dass alle Updates als Bestandteil der
                Software gelten und allen Bestimmungen und Bedingungen dieses
                EULA unterliegen.
              </li>
            </ol>
          </li>

          <li>
            <b> LINKS ZU DRITTEN UND ZUM SUPPORT </b>
            <ol>
              <li>
                Sie können im Rahmen der Benutzung der Software eine Verbindung
                zu Websites von Dritten, beispielsweise zu der
                Remote-Desktop-Support-Plattform und dem externem Label-Drucker
                Team Viewer, aufbauen. TREND hat keine Kontrolle über diese
                Dritt-Websites und ist auch nicht für die Inhalte von
                Dritt-Websites, für Links auf diesen Dritt-Websites oder für
                Änderungen oder Aktualisierungen an Dritt-Websites
                verantwortlich. TREND übernimmt keine Haftung für Webcasts oder
                andere Formen von Übertragungen, die von Dritt-Websites
                empfangen wurden. TREND stellt Ihnen diese Links zu
                Dritt-Websites nur aus praktischen Gründen zur Verfügung. Das
                Vorhandensein solcher Links bedeutet nicht, dass TREND diese
                Dritt-Websites unterstützt.
              </li>
              <li>
                Wenn Sie mehr über die Software erfahren möchten oder Probleme
                mit deren Benutzung haben, finden Sie auf{" "}
                <a
                  href="https://www.trend-networks.com/in/en/index.aspx"
                  target="_blank"
                >
                  <b>www.trend-networks.com</b>
                </a>
                die regionalen E-Mail-Adressen und Telefonnummern von
                Ansprechpartnern. Dieser EULA verpflichtet TREND nicht,
                Support-Leistungen zu erbringen. Wenn Sie Unterstützung
                benötigen, kann TREND diese gegen eine entsprechende
                Aufwandsentschädigung erbringen. Dieser EULA verleiht Ihnen
                keinen Anspruch auf Updates oder Upgrades an der Software oder
                auf Erweiterungen oder Verbesserungen an der Software, die in
                Zukunft von oder im Namen von TREND entwickelt werden. TREND
                kann Support-Leistungen separat anbieten. Zusätzliche
                Softwarecodes oder entsprechendes Material, das TREND Ihnen im
                Rahmen von Support-Leistungen zur Verfügung stellt, gelten als
                Bestandteil der Software und unterliegen den Bestimmungen und
                Bedingungen dieses EULA.
              </li>
            </ol>
          </li>

          <li>
            <b> VERTRAULICHE INFORMATIONEN </b> <br />
            Sie bestätigen und erklären sich einverstanden, dass die Software,
            ohne Open Source Software, sowie alle Daten, die in gleich welcher
            Form aus der Software und aus dem Geschäft von TREND hervorgehen,
            wertvolles geistiges Eigentum von TREND und als vertrauliche
            Informationen von TREND (<b>vertrauliche Informationen</b>)
            anzusehen sind. Sie erklären sich einverstanden, dass Sie während
            oder nach der Laufzeit dieses EULA niemandem erlauben, solche
            vertraulichen Informationen zu vervielfältigen, zu benutzen oder
            weiterzugeben, es sei denn eine solche Vervielfältigung, Benutzung
            oder Weitergabe wurde von TREND vor jeder Weitergabe ausdrücklich in
            Schriftform genehmigt. Sie haben eine angemessene Sorgfalt und in
            jedem Fall mindestens die gleiche Sorgfalt, die Sie selbst auf Ihre
            eigenen vertraulichen Informationen vergleichbarer Art anwenden,
            anzuwenden, um die unbefugte Weitergabe oder Reproduktion der
            vertraulichen Informationen zu verhindern. Ohne Einschränkung der
            Allgemeingültigkeit des Vorgenannten und in dem Umfang, in dem
            dieser EULA das Kopieren von vertraulichen Informationen gestattet,
            haben alle diese Kopien die gleichen Vertraulichkeitshinweise und
            -texte sowie die gleichen Kennzeichnungen von geistigen
            Eigentumsrechten zu enthalten, die auf den Originalen erscheinen,
            und die Vertragspartei hat detaillierte Aufzeichnungen zum
            Aufbewahrungsort aller vertraulichen Informationen zu führen.
          </li>

          <li>
            <b> RECHT AUF KÜNDIGUNG DES EULA</b>
            <ol>
              <li>
                Dieser EULA wird so lange angewendet, bis er von Ihnen oder
                TREND wie hierin festgelegt gekündigt wird.
              </li>
              <li>
                Sie können diesen EULA jederzeit kündigen, indem Sie aufhören,
                auf die Software zuzugreifen und/oder die Software dauerhaft und
                vollständig von Ihrem Computer deinstallieren.
              </li>
              <li>
                Ihre Rechte erlöschen automatisch und sofort ohne Mitteilung von
                TREND, wenn Sie eine Bestimmung dieses EULA nicht einhalten. In
                diesem Fall haben Sie den Zugriff auf die Software unverzüglich
                zu beenden und/oder die Software zu deinstallieren.
              </li>
              <li>
                TREND kann Ihr Recht auf Benutzung der Software jederzeit mit
                und ohne Einhaltung einer Frist kündigen. Die Bestimmungen
                dieses EULA, die sich auf die Nutzung von Daten, die
                Schadloshaltung, die Haftungsbeschränkung, die Vertraulichkeit,
                die Beilegung von Streitfällen und die Auslegung und die
                einzelnen Bestimmungen dieses Vertrages beziehen, bleiben auch
                nach Kündigung oder Ablauf dieses EULA weiter in Kraft.
              </li>
            </ol>
          </li>

          <li>
            <b> SCHADLOSHALTUNG </b>
            <br />
            Sie erklären sich einverstanden, in dem größten laut Gesetz
            zulässigen Umfang TREND, dessen Tochtergesellschaften und deren
            Direktoren, leitende Angestellte, Angestellte und
            Handlungsbeauftragte zu schützen vor, zu entschädigen und schadlos
            zu halten gegen alle Forderungen, Klagen und Gerichtsverfahren sowie
            gegen alle Verluste, Verpflichtungen, Schadensersatzzahlungen,
            Kosten und Auslagen, einschließlich angemessener
            Rechtsanwaltsgebühren, die sich aus der Benutzung der Software,
            einschließlich des Zugriffs auf die Software und/oder der
            Installation oder Benutzung der Software, oder der Verletzung dieses
            EULA, durch Sie und jede andere Person, die mit Ihrem Konto oder
            Passwort handelt, ergeben.
          </li>

          <li>
            <b> HAFTUNGSBESCHRÄNKUNG</b>
            <ol>
              <li>
                DIE HAFTUNGSAUSSCHLÜSSE UND HAFTUNGSBESCHRÄNKUNGEN VON TREND
                GELTEN NUR FÜR DEN JEWEILS GESETZLICH ZULÄSSIGEN UMFANG. SIE
                GELTEN AUCH FÜR DIE HAFTUNG VON TREND BEI TOD ODER
                KÖRPERVERLETZUNG, DIE DURCH DIE FAHRLÄSSIGKEIT VON TREND ODER
                SEINER ANGESTELLTEN, HANDLUNGSBEAUFTRAGTEN ODER
                UNTERAUFTRAGNEHMER VERURSACHT WURDEN, SOWIE BEI BETRUG UND
                ARGLISTIGER TÄUSCHUNG.
              </li>
              <li>
                SIE ERKLÄREN AUSDRÜCKLICH, DASS SIE VERSTEHEN UND EINVERSTANDEN
                SIND, DASS IHRE BENUTZUNG DER SOFTWARE NACH IHREM FREIEM
                ERMESSEN UND AUF IHR EIGENES RISIKO ERFOLGT UND DASS DIE
                SOFTWARE „WIE BESEHEN“ UND „WIE VERFÜGBAR“ OHNE AUSDRÜCKLICHE
                ODER STILLSCHWEIGENDE GEWÄHRLEISTUNG GLEICH WELCHER ART
                BEREITGESTELLT WIRD. SIE ALLEIN SIND FÜR SCHÄDEN AN IHREM
                COMPUTER ODER AN EINEM ANDEREN GERÄT ODER FÜR DEN VERLUST VON
                DATEN VERANTWORTLICH, DER SICH AUS DIESER BENUTZUNG ERGIBT.
                WEITERHIN SCHLIESST TREND IN BEZUG AUF DIESE SOFTWARE
                AUSDRÜCKLICH ALLE ANDEREN AUSDRÜCKLICHEN UND AUCH
                STILLSCHWEIGENDEN GEWÄHRLEISTUNGEN UND ZUSICHERUNGEN GLEICH
                WELCHER ART, INSBESONDERE DIE STILLSCHWEIGENDE GEWÄHRLEISTUNG
                DER MARKTGÄNGIGKEIT UND DER EIGNUNG FÜR EINEN BESTIMMTEN ZWECK
                SOWIE DIE GEWÄHRLEISTUNG DER NICHTVERLETZUNG VON RECHTEN
                DRITTER, AUS. DA EINIGE LÄNDER KEINEN VERZICHT AUF BZW. KEINEN
                AUSSCHLUSS STILLSCHWEIGENDER GEWÄHRLEISTUNGEN GESTATTEN, TREFFEN
                DIE OBEN GENANNTEN AUSSCHLÜSSE UND BESCHRÄNKUNGEN MÖGLICHERWEISE
                NICHT AUF SIE ZU. TREND GEWÄHRLEISTET NICHT, DASS IHR
                BENUTZERERLEBNIS IN BEZUG AUF DIE SOFTWARE STÖRUNGSFREI IST,
                DASS DIE IN DER SOFTWARE ENTHALTENEN FUNKTIONEN ODER DIE VON DER
                SOFTWARE ERBRACHTEN ODER BEREITGESTELLTEN DIENSTE IHREN
                ANFORDERUNGEN GERECHT WERDEN, DASS DER BETRIEB DER SOFTWARE ODER
                DER DIENSTE UNTERBRECHUNGS- ODER FEHLERFREI ERFOLGT ODER DASS
                MÄNGEL AN DER SOFTWARE ODER DEN DIENSTEN BEHOBEN WERDEN.
                MÜNDLICHE ODER SCHRIFTLICHE INFORMATIONEN ODER AUSKÜNFTE, DIE
                TREND ODER SEINE BEVOLLMÄCHTIGTEN VERTRETER GEBEN, STELLEN KEINE
                ZUSICHERUNGEN ODER GEWÄHRLEISTUNGEN DAR.
              </li>
              <li>
                SIE ERKLÄREN AUSDRÜCKLICH, DASS SIE VERSTEHEN UND EINVERSTANDEN
                SIND, DASS, MIT AUSNAHME VON ARTIKEL 10.1, TREND, SEINE
                TOCHTERGESELLSCHAFTEN UND LIZENZGEBER IHNEN GEGENÜBER JEGLICHE
                HAFTUNG FÜR VERLUSTE ODER SCHÄDEN GLEICH WELCHER ART UND IN
                GLEICH WELCHER HÖHE SOWIE NACH GLEICH WELCHER HAFTUNGSTHEORIE
                AUSSCHLIESSEN. DABEI IST ES UNERHEBLICH, OB ES SICH UM DIREKTE,
                INDIREKTE, BEILÄUFIG ENTSTANDENE ODER BESONDERE VERLUSTE ODER
                SCHÄDEN ODER UM VERSCHÄRFTEN SCHADENSERSATZ HANDELT SOWIE OB
                DIESE VERLUSTE ODER SCHÄDEN, EINSCHLIESSLICH DES VERLUSTES VON
                DATEN ODER DER BESCHÄDIGUNG IHRER GERÄTE, VON IHNEN DURCH DIE
                BENUTZUNG DER SOFTWARE ERLITTEN WURDEN SOWIE UNABHÄNGIG DAVON,
                OB SIE ODER IHRE VERTRETER ÜBER DIE MÖGLICHKEIT EINES SOLCHEN
                VERLUSTES INFORMIERT WAREN ODER DAVON HÄTTEN KENNTNIS HABEN
                MÜSSEN.
              </li>
              <li>
                BITTE ERSTELLEN SIE SICHERUNGSKOPIEN DER INHALTE UND DATEN, DIE
                MIT DER SOFTWARE BENUTZT WERDEN. TREND EMPFIEHLT, VON ALLEN
                INHALTEN UND DATEN, DIE IN VERBINDUNG MIT DER SOFTWARE GENUTZT
                WERDEN, SICHERUNGSKOPIEN ZU ERSTELLEN, UM SICH BEI PROBLEMEN MIT
                DER SOFTWARE ZU SCHÜTZEN.
              </li>
            </ol>
          </li>

          <li>
            <b> ÄNDERUNGEN AM EULA-VERTRAG </b>
            <br />
            TREND darf diesen EULA, einschließlich der von Ihnen für die
            Benutzung der Software zu zahlenden Gebühren, jederzeit durch eine
            per E-Mail, online, über die Software oder auf sonstige Weise
            erfolgte Mitteilung zur betreffenden Änderung ändern. Eine solche
            Änderung tritt innerhalb von dreißig (30) Tagen ab dem Datum einer
            solchen Mitteilung in Kraft. Sie müssen diese Änderung, wie in der
            Mitteilung angegeben, bestätigen und sich mit dieser einverstanden
            erklären. Wenn Sie diese in der Mitteilung gemachte Änderung nicht
            bestätigen und sich nicht damit einverstanden erklären, ist TREND
            berechtigt, diesen EULA mit einer Frist von einem (1) Monat zu
            kündigen.
          </li>

          <li>
            <b> MITTEILUNGEN </b>
            <ol>
              <li>
                12.1 Alle Mitteilungen oder sonstigen Kommunikationen, die eine
                Vertragspartei in Verbindung mit diesem EULA macht, haben in
                Schriftform zu erfolgen und sind persönlich zu übergeben oder
                als vorausbezahlte vorrangig zugestellte Post oder mit
                Lieferdienst zur Zustellung am nächsten Arbeitstag an die
                Adresse des eingetragenen Geschäftssitzes (für Unternehmen) oder
                an den Hauptgeschäftssitz (in allen anderen Fällen) aufzugeben.
              </li>
              <li>
                Alle Mitteilungen und Kommunikationen gelten wie folgt als beim
                Empfänger eingegangen: (i) bei persönlicher Übergabe mit der
                Unterzeichnung einer Empfangsquittung oder zu dem Zeitpunkt, an
                dem die Mitteilung bei der ordnungsgemäßen Adresse hinterlassen
                wurde, (ii) bei Zustellung mit vorausbezahlter vorrangig
                zugestellter Post oder einem anderen Lieferdienst zur Zustellung
                am nächsten Arbeitstag um 9:00 Uhr am zweiten Geschäftstag nach
                Aufgabe oder zu dem Zeitpunkt, der vom Lieferdienst vermerkt
                wurde und (iii) bei E-Mail-Versand zu dem Zeitpunkt der
                Übertragung oder, falls dieser Zeitpunkt am Empfangsort
                außerhalb der Geschäftsstunden liegt, mit dem Wiederbeginn der
                Geschäftszeiten, d. h. 9:00 Uhr bis 17:00 Uhr von Montag bis
                Freitag, an Tagen ohne gesetzlichen Feiertag am Empfangsort.
              </li>
            </ol>
          </li>

          <li>
            <b> MASSGEBENDES RECHT UND GERICHTSSTAND</b>
            Dieser EULA sowie alle Streitfälle und Forderungen, einschließlich
            außervertraglicher Streitfälle und Forderungen, die sich in oder in
            Verbindung mit diesem EULA oder dem Vertragsgegenstand oder den
            einzelnen Bestimmungen ergeben, unterliegen den Gesetzen von England
            und Wales und sind in Übereinstimmung mit diesen auszulegen. Die
            Vertragsparteien erklären sich unwiderruflich damit einverstanden,
            dass die Gerichte von England und Wales die ausschließliche
            Zuständigkeit besitzen, um jegliche Streitfälle oder Forderungen,
            einschließlich außervertraglicher Streitfälle und Forderungen, die
            sich aus oder in Verbindung mit diesem EULA oder dem
            Vertragsgegenstand oder den einzelnen Bestimmungen ergeben,
            beizulegen.
          </li>

          <li>
            <b>SONSTIGE BESTIMMUNGEN</b>
            <br />
            Dieser EULA, einschließlich der Ergänzungen oder Änderungen zu
            diesem EULA, stellt den gesamten Vertrag dar, den Sie und TREND zu
            der Software und gegebenenfalls zu den Supportleistungen
            abgeschlossen haben. Er ersetzt alle früheren oder zeitgleich
            erfolgten mündlichen und schriftlichen Kommunikationen, Angebote und
            Zusicherungen in Bezug auf die Software und andere in diesem EULA
            genannte Themen. Falls die Bestimmungen von Richtlinien oder die
            Bedingungen von Supportleistungen von TREND in Widerspruch zu den
            Bedingungen dieses EULA stehen, hat dieser EULA Vorrang. Falls eine
            Bestimmung dieses EULA für nichtig, ungültig, nicht durchsetzbar
            oder unrechtmäßig angesehen wird, so gilt diese Bestimmung als
            neuformuliert, um die ursprüngliche Absicht der Vertragsparteien im
            größtmöglichen Maße und in Übereinstimmung mit den geltenden
            Gesetzen wiederzugeben, wobei die anderen Bestimmungen ohne
            Einschränkung in Kraft bleiben. Die Nichtausübung oder
            Nichtdurchsetzung eines Rechtes oder einer Bestimmung dieses EULA
            durch TREND bedeutet nur dann einen Verzicht auf dieses Recht oder
            diese Bestimmung, wenn TREND dies in Schriftform bestätigt und
            vereinbart hat. Weder eine Verhaltensweise zwischen den
            Vertragsparteien noch ein Handelsbrauch bewirken eine Änderung einer
            Bestimmung dieses EULA. Ohne die vorherige schriftliche Zustimmung
            von TREND, die TREND nach freien Ermessen mit oder ohne Bedingungen
            erteilen kann, dürfen Sie diesen EULA oder Ihre Rechte gemäß diesem
            EULA nicht abtreten und jede versuchte Abtretung ohne die genannte
            Zustimmung gilt als null und nichtig. Vorbehaltlich der oben
            genannten Einschränkung ist dieser EULA für TREND rechtsverbindlich,
            kommt TREND zugute und ist von TREND und seinen jeweiligen
            Rechtsnachfolgern und Bevollmächtigten durchsetzbar. Gemäß diesen
            Bedingungen kann TREND seine Rechte und Pflichten an ein anderes
            Unternehmen übertragen.
          </li>
        </ol>
      </span>
    </React.Fragment>
  );
};

export default TermsAndCondition;
